<common-otp-verification/>
@if (this.universalService.show2FApopUp) {
    <lib-passphrase-login/>
}

@if (!router.url.includes('/userprofile') && universalService.showPassPhraseReset) {
    <lib-reset-passpharse/>
}
  

<!-- @if ( !universalService?.userLoggedIn && this.universalService.activeRepo == 'share' && (this.universalService.showRecoverpopUp||this.universalService.showRecoverVerifyemailpopUp|| this.universalService.recoverVerifyOTPpopUp)) {
    <lib-recover-account/>
}
@if ( !universalService?.userLoggedIn) {
    <lib-display-usr-details-modal/>
}
@if ( !universalService?.userLoggedIn && this.loginImplRef?.noMappingFoundModal) {
    <lib-no-mapping-found-modal/>
} -->

@if(!universalService.iframeLogin){
    @if (universalService?.userLoggedIn) {
        <span class="u-name">{{this.universalService.firstName}}
            {{this.universalService.lastName}}
        </span>
        <div class="sidebar fixed-width" id="postLoginDesktopLeftMenu" [ngClass]="[universalService.isTourON  && !this.universalService.showTourForAllJioCloudUsr ? 'tourLeftMenu' : '']">
                @if (universalService.activeRepo == 'main') {
                    <common-new-create-btn />
                }
                <!-- Menu Items -->
                @for (item of menuItems; track item; let i = $index) {
                    @if(!item.hidden){
                        <div class="menu-item" id="{{item.id}}"  (click)="redirectToRespsectiveRoute(item)">
                            @if(item.title != 'More Features'){
                                @if(item.imgPath){
                                    <span>
                                      <img [src]= "'../assets/images/' + item.imgPath">
                                    </span> 
                                }@else{
                                    <span [class]="item.icon"></span> 
                                }
                                <a href="javascript:void(0);">{{ item.title }}</a>
                                @if(item.badge){
                                    <span class="badge badge-pill" >{{ item.badge }}</span>
                                }
                            }
                        </div>
                    }
                }
                <!-- Secondry menu -->
                @if(secondryMenuItems?.length > 0){
                    <div class="secondry-menu-cont">
                        @for (secondryItems of secondryMenuItems; track secondryItems; let i = $index) {
                            @if(!secondryItems.hidden){
                                <div class="menu-item"   id="{{secondryItems.id}}" (click)="redirectToRespsectiveRoute(secondryItems)">
                                    @if(secondryItems.title != 'More Features'){
                                        @if(secondryItems.imgPath){
                                            <span>
                                              <img [src]= "'../assets/images/' + secondryItems.imgPath">
                                            </span> 
                                        }@else{
                                            <span [class]="secondryItems.icon"></span> 
                                        }
                                        <a href="javascript:void(0);">{{ secondryItems.title }}</a>
                                        @if(secondryItems.badge){
                                            <span class="badge badge-pill" >{{ secondryItems.badge }}</span>
                                        }
                                    }
                                </div>
        
                                
                            }  
                        }
                    </div>  
                }
                <!--More menu -->
                @if(!this.userDetails["jcEntInfo"] && moreMenuItems[0]){
                    <div class="more-menu-cont">
                        @for (moreItem of moreMenuItems; track moreItem; let i = $index) {
                            @if(moreItem.moremenu){
                                <a (click)="toggleDropdown(moreItem)" class="dropdown-toggle more-dropdown" href="javascript:void(0);" id="left-menu-more-menu">
                                    <span [class]="moreItem.icon"></span> {{ moreItem.title }}<span class="dropdown-tohggle-icon" [ngClass]="moreItem.expanded ? 'NeueCollapse':'NeueExpand'"></span>
                                </a>
                                <div class="moremenu" id="left-more-menu">
                                    @for(sub of moreItem.moremenu; track sub){
                                        @if(!sub.hidden){
                                            <div class="menu-item"  id="{{sub.id}}" (click)="redirectToRespsectiveRoute(sub)">
                                                <span [class]="sub.icon"></span> 
                                                <a href="javascript:void(0);">{{ sub.title }}</a>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        }
                    </div>
                }
                
                @if(trashItem?.title){
                    <div class="trash-menu-cont">
                        <div class="menu-item"  id="{{trashItem.id}}" (click)="redirectToRespsectiveRoute(trashItem)">
                            <span [class]="trashItem?.icon"></span> 
                            <a href="javascript:void(0);">{{ trashItem?.title}}</a> 
                        </div>
                    </div>
                }
                
                <!-- Storage Section -->
                
                @if(goToAdminConsoleItem?.title && userDetails?.enableAdminConsole){
                    <div class="admin-console-cont">
                        <div class="menu-item switch-admin"  id="{{goToAdminConsoleItem.id}}" (click)="switchAdminConsoleView()">
                            <a href="javascript:void(0);">{{ goToAdminConsoleItem?.title}}</a> 
                            <span [class]="goToAdminConsoleItem?.icon"></span> 
                        </div>
                    </div>
                }
                 @if(menuItems.length > 0){
                    @if ( userDetails?.quota?.totalUsedQuota != undefined && userDetails?.quota?.totalAllocatedQuota != undefined) {
                        <div class="storage" (click)="openProfileView()">
                            <p class="storage-tittle">Storage</p>
                            @if (userDetails.isFamilyMember == 'Y') {
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': (userTotalUsedStorage *100 / userTotalStorage) + '%','max-width': '100%', 'height': '8px'}"
                                        [ngClass]="[((userDetails?.quota?.totalAllocatedQuota - userDetails?.quota?.totalUsedQuota) <= 19585531) ? 'full-storage-color' : 'sufficient-storage-color' ]">
                                    </div>
                                </div>
                                <p class="storage-value-cont">
                                    @if (userDetails?.quota?.totalUsedQuota == 0) {
                                    0 GB
                                    consumed of
                                    {{userTotalStorage | bytesConversion:1 }}
                                    }
                                    @if (userDetails?.quota?.totalUsedQuota > 0) {
                                        {{ userTotalUsedStorage| bytesConversion:1}}
                                        consumed of
                                        {{userTotalStorage| bytesConversion:1 }}
                                    }
                                </p>
                            }
                            @if (userDetails?.isFamilyMember == 'N') {
                                <div class="progress" >
                                    <div class="progress-bar" role="progressbar"
                                    [ngStyle]="{'width': (userDetails?.quota?.totalUsedQuota*100 /userDetails?.quota?.totalAllocatedQuota) + '%','max-width': '100%', 'height': '8px'}"
                                    [ngClass]="[((userDetails?.quota?.totalAllocatedQuota - userDetails?.quota?.totalUsedQuota) <= 19585531) ? 'full-storage-color' : 'sufficient-storage-color' ]">
                                    </div>
                                </div>
                                <p class="storage-value-cont">
                                    @if (userDetails?.quota?.totalUsedQuota == 0) {
                                        0 GB
                                        consumed of
                                        {{userDetails?.quota?.totalAllocatedQuota | bytesConversion:1 }}
                                    }
                                    @if (userDetails?.quota?.totalUsedQuota > 0) {
                                        {{ userDetails?.quota?.totalUsedQuota | bytesConversion:1}}
                                        consumed of
                                        {{userDetails?.quota?.totalAllocatedQuota | bytesConversion:1 }}
                                    }
                                </p>
                            }
                            @if (userDetails?.allowStoragePurchase == 'Y' && (userDetails?.paidPlan?.planStatus != 'A' && userDetails?.paidPlan?.planStatus != 'G')  || userDetails?.allowStoragePurchase == 'N') {
                                <img src="../assets/images/paid_plan_banner.svg"  (click)="viewPlanDetails($event)"/>
                            }
                            @if (userDetails?.allowStoragePurchase == 'Y' && (userDetails?.paidPlan?.planStatus == 'A'||userDetails?.paidPlan?.planStatus == 'G')) {
                                <span class="li-membership-details" (click)="viewPlanDetails($event)">
                                JioAICloud Membership <span class="premium-tag">PREMIUM</span>
                                </span>
                            }
                        </div>
                    }
                }
                @if(menuItems.length > 0 &&  !userDetails?.enableAdminConsole && (userData.authProviderId == 4 || userData.authProviderId == 26) && userData['eligibleForUpgrade'] == 'Y' && userData['quotaUpgraded'] == 'N'){
                    <div class="user-communication user-communication-storage" (click)="redirectFooterLinks('Download App')">
                        <img src="../assets/images/user-communication.png">
                    </div>
                }
                <!-- Footer Links -->
                @if(footerLinks?.length > 0){
                    <div class="footer">
                        @for(link of footerLinks; track link){
                            @if(!link.hidden){
                                <p (click)="redirectFooterLinks(link)">
                                    <a href="javascript:void(0);">{{ link.title }}</a>
                                    <span [class]="link.icon"></span>
                                </p>
                            }
                        }
                    </div>
                }
        </div>
    }
}
